module.exports = __webpack_public_path__ + "static/media/cover_changemakers.a7b78c57.jpg";